import { useSelector } from "react-redux";
import { Navigate, useLocation} from 'react-router-dom'

const NoAccessMessage = () => (
    <div className="d-flex justify-content-center align-items-center" style={{ height: 300 }}>
        <p style={{ color: '#718094', fontSize: 16 }}>Nemáte prístup k tejto sekcii.</p>
    </div>
);

const AuthGuard = ({ children, requireVerified = true, module, requireOwner = false, fallback }) => {
    const users = useSelector(state=>state.users);
    const activeTenantBlocked = useSelector(state => state.users.data?.activeTenantBlocked);
    const isOwner = useSelector(state => state.users.data?.isOwner);
    const modules = useSelector(state => state.users.data?.modules);
    let location = useLocation();

    if(!users.auth){
        return <Navigate to="/account/login" state={{from:location}} replace/>
    }

    if(requireVerified && !users.data.verified){
        return <Navigate to="/account/not-verified" replace/>
    }

    if(activeTenantBlocked && location.pathname !== '/dashboard'){
        return <Navigate to="/dashboard" replace/>
    }

    if(requireOwner && !isOwner){
        return <NoAccessMessage />
    }

    if(module && modules !== 'all' && !(modules ?? []).includes(module)){
        return fallback ?? <NoAccessMessage />
    }

    return children
}

export default AuthGuard;
